import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function ConnectorsOAuthCallbackPage() {
  const { t } = useTranslation('knox-aiops');
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');

    if (error) {
      setStatus('error');
      return;
    }

    setStatus('success');
    // Navigate back to last workspace after a brief pause
    const lastWorkspace = sessionStorage.getItem('lastWorkspaceId');
    const target = lastWorkspace ? `/workspaces/${lastWorkspace}` : '/workspaces';
    const timer = setTimeout(() => navigate(target, { replace: true }), 1500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface">
      <div className="text-center">
        {status === 'loading' && (
          <span className="material-symbols-outlined text-4xl text-primary block mb-3 animate-spin">progress_activity</span>
        )}
        {status === 'success' && (
          <span className="material-symbols-outlined text-4xl text-success block mb-3">check_circle</span>
        )}
        {status === 'error' && (
          <span className="material-symbols-outlined text-4xl text-error block mb-3">error</span>
        )}
        <p className="text-sm text-on-surface-variant">
          {status === 'success' && t('settings.connectors.oauthCallback.success')}
          {status === 'error' && t('settings.connectors.oauthCallback.error')}
          {status === 'loading' && t('settings.connectors.oauthCallback.loading')}
        </p>
        {status === 'error' && (
          <button
            onClick={() => navigate(-1)}
            className="mt-4 text-sm text-primary hover:underline cursor-pointer"
          >
            {t('settings.connectors.oauthCallback.back')}
          </button>
        )}
      </div>
    </div>
  );
}
